

import { createContext } from 'react'

const pdfContext = createContext();

export default pdfContext;